module.exports = __webpack_public_path__ + "img/winerackdog05.0c269b1e.jpg";